import { 
    apiRequest,
    AwardPeriodCreate,
    AwardPeriodDetail
} from '../../../../../services/adapters/kepegawaian/penghargaanService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest('post', AwardPeriodCreate, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest('get', AwardPeriodDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
 
}

export default CreateRepository;